const BRAND_TV_DOMAIN = import.meta.env.VITE_BRAND_TV_DOMAIN;
const WEBINAR_PLUS_DOMAIN = import.meta.env.VITE_WEBINAR_PLUS_DOMAIN;

export const getFromAppConfigForCurrentLocation = () => {
  try {
    if (window.location.hostname.endsWith(BRAND_TV_DOMAIN)) {
      return JSON.parse(import.meta.env.VITE_BRAND_TV_AUTH_CONFIG);
    }

    if (window.location.hostname.endsWith(WEBINAR_PLUS_DOMAIN)) {
      return JSON.parse(import.meta.env.VITE_WEBINAR_PLUS_AUTH_CONFIG);
    }
  } catch (error) {
    console.error('Error parsing from app config', error);
  }

  return undefined;
};
